import { ref, watch } from 'vue';
import axios from 'axios';


export default {
  __name: 'Search',
  props: {
    selectedMedications: {
        type: Array,
        required: true,
    },
    hasErrors: {
        type: Boolean,
        required: true,
    },
},
  emits: ['addItem'],
  setup(__props, { expose, emit }) {
  expose();

const props = __props;



const isOpen = ref(false);
const search = ref('');
const isLoading = ref(false);
const searchResults = ref([]);

let controller = null;

const toggleIsOpen = (status) => {
    setTimeout(() => {
        isOpen.value = status;
    }, 0);
};

let timeout = null;
watch(search, (value) => {
    if (value.length > 1) {
        controller = new AbortController();
        clearTimeout(timeout);
        isLoading.value = true;
        timeout = setTimeout(() => {
            axios
                .get(`${jsData.siteUrl}/wp-json/doctor/v1/medications-list?search=${value}`, {
                    signal: controller.signal,
                })
                .then((response) => {
                    searchResults.value = response.data;
                    isOpen.value = true;
                    isLoading.value = false;
                });
        }, 500);
    }
});



const addItemToList = (item) => {
    if (!item.title || !item.title.length) return;

    emit('addItem', {
        ...item,
        variants: item.variants || null,
        selectedVariant:
            item.variants && item.variants !== 'custom' ? item.variants[0].single_dosage : null,
    });

    if (controller) {
        controller.abort();
    }

    isLoading.value = false;
    search.value = '';
    searchResults.value = [];
    isOpen.value = false;
};

const __returned__ = { props, isOpen, search, isLoading, searchResults, get controller() { return controller }, set controller(v) { controller = v }, toggleIsOpen, get timeout() { return timeout }, set timeout(v) { timeout = v }, emit, addItemToList, ref, watch, get axios() { return axios } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}